import { render, staticRenderFns } from "./TabForm.vue?vue&type=template&id=d324a0a2"
import script from "./TabForm.vue?vue&type=script&lang=js"
export * from "./TabForm.vue?vue&type=script&lang=js"
import style0 from "./TabForm.vue?vue&type=style&index=0&id=d324a0a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports